import css from "./popUp.module.css";
import React from "react";

const PopSp = React.forwardRef(({ onClick }, ref) => {
  return (
    <div className={css.popSPWrap} ref={ref} onClick={onClick}>
      <p className={css.mainPopP}>
        Для організаторів СП (спільних покупок), корпоративних замовлень,
        покупок для школи/садочку пропонуємо індивідуальні умови співпраці.
        Реєструйтеся на сайті зі статусом "СП" та використовуйте гуртову форму
        замовлення на сторінці "Прайс для гурту". Для узгодження деталей
        звертайтеся:
        <a href="mailto:sales@chasmaistriv.com.ua">sales@chasmaistriv.com.ua</a>
      </p>
    </div>
  );
});

export default PopSp;
